import React from "react";
import { registerToast } from "../../service/toastService";

const VARIANTS = {
    success: {
        border: "rgba(34,197,94,0.35)",
        background: "rgba(20,83,45,0.96)",
        icon: "fa-check-circle",
    },
    error: {
        border: "rgba(224,82,82,0.35)",
        background: "rgba(127,29,29,0.96)",
        icon: "fa-times-circle",
    },
    warning: {
        border: "rgba(245,158,11,0.35)",
        background: "rgba(146,64,14,0.96)",
        icon: "fa-exclamation-triangle",
    },
    info: {
        border: "rgba(59,130,246,0.35)",
        background: "rgba(30,64,175,0.96)",
        icon: "fa-info-circle",
    },
    primary: {
        border: "rgba(99,102,241,0.35)",
        background: "rgba(67,56,202,0.96)",
        icon: "fa-star",
    },
    secondary: {
        border: "rgba(107,114,128,0.35)",
        background: "rgba(55,65,81,0.96)",
        icon: "fa-layer-group",
    },
    danger: {
        border: "rgba(239,68,68,0.35)",
        background: "rgba(153,27,27,0.96)",
        icon: "fa-skull-crossbones",
    },
    dark: {
        border: "rgba(75,85,99,0.35)",
        background: "rgba(17,24,39,0.96)",
        icon: "fa-moon",
    },
    light: {
        border: "rgba(209,213,219,0.8)",
        background: "rgba(249,250,251,0.96)",
        icon: "fa-sun",
        color: "#111827",
    },
    loading: {
        border: "rgba(59,130,246,0.35)",
        background: "rgba(30,64,175,0.96)",
        icon: "fa-spinner fa-spin",
    },
    save: {
        border: "rgba(34,197,94,0.35)",
        background: "rgba(20,83,45,0.96)",
        icon: "fa-save",
    },
    delete: {
        border: "rgba(239,68,68,0.35)",
        background: "rgba(153,27,27,0.96)",
        icon: "fa-trash",
    },
    update: {
        border: "rgba(59,130,246,0.35)",
        background: "rgba(30,64,175,0.96)",
        icon: "fa-edit",
    },
    upload: {
        border: "rgba(14,165,233,0.35)",
        background: "rgba(3,105,161,0.96)",
        icon: "fa-upload",
    },
    download: {
        border: "rgba(168,85,247,0.35)",
        background: "rgba(107,33,168,0.96)",
        icon: "fa-download",
    },
    network: {
        border: "rgba(6,182,212,0.35)",
        background: "rgba(14,116,144,0.96)",
        icon: "fa-wifi",
    },
    lock: {
        border: "rgba(245,158,11,0.35)",
        background: "rgba(146,64,14,0.96)",
        icon: "fa-lock",
    },
    logout: {
        border: "rgba(107,114,128,0.35)",
        background: "rgba(55,65,81,0.96)",
        icon: "fa-sign-out-alt",
    },
};

class ToastContainer extends React.Component {
    state = {
        toast: null,
    };

    componentDidMount() {
        registerToast((message, variant) => {
            clearTimeout(this.timer);

            this.setState({
                toast: { message, variant },
            });

            this.timer = setTimeout(() => {
                this.setState({ toast: null });
            }, 3500);
        });
    }

    render() {
        if (!this.state.toast) return null;

        const variant = VARIANTS[this.state.toast.variant] || VARIANTS.success;

        return (
            <div
                style={{
                    position: "fixed",
                    top: 18,
                    right: 18,
                    zIndex: 3000,
                    minWidth: 260,
                    maxWidth: 420,
                    padding: "12px 14px",
                    borderRadius: 6,
                    border: `1px solid ${variant.border}`,
                    background: variant.background,
                    color: "#fff",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                    fontSize: 13,
                    fontFamily: "var(--font-mono)",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                }}
            >
                <i className={`fa ${variant.icon}`}></i>
                <span>{this.state.toast.message}</span>
            </div>
        );
    }
}

export default ToastContainer;